let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eB4K3")).then(() => parcelRequire('36IIq'));